/**
 * Options shared by the three Sentry runtimes (browser, Node server, Edge).
 *
 * Kept free of imports so it is safe to load from `instrumentation-client.ts`
 * and from the Edge runtime, both of which run before the app bundle.
 */

/**
 * Sentry is opt-in: with no DSN configured every `Sentry.init` call is skipped,
 * so local dev and CI run with the SDK completely inert.
 */
export const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN || process.env.SENTRY_DSN || "";

export const SENTRY_ENABLED = SENTRY_DSN.length > 0;

export const SENTRY_ENVIRONMENT =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ||
  process.env.SENTRY_ENVIRONMENT ||
  process.env.NODE_ENV ||
  "development";

function rate(raw: string | undefined, fallback: number): number {
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) return fallback;
  return parsed;
}

/** Tracing is sampled down in production so an ERP under load does not flood the quota. */
export const SENTRY_TRACES_SAMPLE_RATE = rate(
  process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE,
  process.env.NODE_ENV === "production" ? 0.1 : 1,
);

export const SENTRY_DEBUG = process.env.SENTRY_DEBUG === "1";

/**
 * This app stores tenant, staff, and customer records. Never let the SDK attach
 * request bodies, cookies, or user identity on its own — anything Sentry should
 * know has to be set deliberately with `Sentry.setUser`.
 */
export const SENTRY_SEND_DEFAULT_PII = false;
